export default __webpack_public_path__ + "static/media/LogoMandeSeguroWhite.8d26b462.svg";